import { Table, Typography, Affix, Space, Modal, Button, Row } from "antd";
import DeleteVoucherModal from "../DeleteVoucherModal";
import useVouchersTable from "./useVouchersTable";
import VoucherFilters from "../VouchersFilters";
import "./styles.css";

const { Text } = Typography;

const VouchersTable = () => {
	const {
		vouchersColumns,
		onRowSelectionChange,
		onPagination,
		paginatorInfo,
		loading,
		rows,
		selectedRowIds,
		clearSelectedRows,
		refetch,
		showDeactivateModal,
		setShowDeactivateModal,
		selectedVoucher,
		handleToggleVoucherStatus,
		isToggleVoucher,
	} = useVouchersTable();
	return (
		<div>
			<VoucherFilters submitFilters={refetch} total={paginatorInfo.total} />
			<Table
				rowSelection={{
					type: "checkbox",
					onChange: onRowSelectionChange,
				}}
				onChange={onPagination}
				pagination={{ total: paginatorInfo.total, showSizeChanger: true }}
				columns={vouchersColumns}
				loading={loading}
				dataSource={rows}
				locale={{
					emptyText: loading
						? "Loading data..."
						: "There are no results that match the applied filters",
				}}
			/>
			{selectedRowIds.length && (
				<Affix
					style={{
						textAlign: "center",
					}}
					offsetBottom={10}
				>
					<Space
						style={{
							backgroundColor: "#4A4A4A",
							padding: "10px 15px",
							borderRadius: 10,
							color: "#fff",
						}}
					>
						<Text strong style={{ color: "#fff" }}>
							{selectedRowIds.length} of {paginatorInfo.total} Items Selected
						</Text>
						<DeleteVoucherModal
							ids={selectedRowIds}
							buttonType="primary"
							cleanUp={clearSelectedRows}
						/>
					</Space>
				</Affix>
			)}
			<Modal
				title="Deactivate Voucher"
				centered
				open={showDeactivateModal}
				closable
				onCancel={() => setShowDeactivateModal(false)}
				footer={
					<Row justify="center">
						<Button
							danger
							type="primary"
							loading={isToggleVoucher}
							onClick={() =>
								handleToggleVoucherStatus(
									selectedVoucher?.id,
									selectedVoucher?.name,
								)
							}
						>
							Deactivate Voucher
						</Button>
						<Button onClick={() => setShowDeactivateModal(false)}>
							Cancel
						</Button>
					</Row>
				}
			>
				<Text strong>
					Do you still want to deactivate voucher {selectedVoucher?.name}?
				</Text>
			</Modal>
		</div>
	);
};

export default VouchersTable;
